import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';

/** Bouton rond « retour en haut » du pied de page de Beaconsfield. */
export function BackToTop({
  threshold = 600
}: {
  threshold?: number;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);
  if (!visible) return null;
  return <button type="button" onClick={() => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })} aria-label="Retour en haut de la page" className="fixed bottom-24 right-5 z-30 grid h-11 w-11 place-items-center rounded-full bg-white text-ville-navy shadow-lg shadow-ville-navy/20 ring-1 ring-ville-navy/10 transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-592" data-mp="2nvzr2vokhzxu">
      <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-593" data-mp="13ibe1cdw25ua" />
    </button>;
}